import React from 'react';
import Page from "../../containers/Page/Page";
import { Button, Box, Typography, TableContainer, Table, TableHead, TableCell, TableRow, TableBody, Grid, Chip } from "@material-ui/core";
import { Pagination } from '@material-ui/lab';
import SearchField from "../../components/SearchField";
import { useHistory } from "react-router-dom";
import { api } from '../../services/api';
import moment from 'moment';
import { Helpers } from '../../utils/Helpers';
import { usePermissions } from '../../hooks/permissions';

interface IData {
    data: {
        id: string;
        nome: string;
        tipo: string;
        bombas: { nome: string; }[];
        ativa: boolean;
        created_at: string;
    }[];
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
}

function Modelos() {

    const history = useHistory();
    const permissions = usePermissions();
    const query = new URLSearchParams(history.location.search);

    const [error, setError] = React.useState<string>('');
    const [loading, setLoading] = React.useState<boolean>(false);
    const [search, setSearch] = React.useState<string>(query.get('search') || '');
    const [data, setData] = React.useState<IData>();

    /**
     * Ao carregar a página.
     */
    React.useEffect(() => {
        handleFetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * Carregar modelos.
     * @param page 
     */
    async function handleFetch(page: number = Number(query.get('page')) || 1) {
        setLoading(true);
        try {
            const url = `/modelos?search=${search}&page=${page}`;
            const response = await api.get(url);
            history.push(url);
            setData(response.data.object);
            setError('');
        } catch (error: any) {
            setError(Helpers.errorFormat(error));
        }
        setLoading(false);
    }

    /**
     * Pesquisar com ENTER.
     * @param event 
     */
    function handleSearchKeyUp(event: React.KeyboardEvent<HTMLTextAreaElement | HTMLInputElement>) {
        if (event.key === 'Enter') {
            handleFetch(1);
        }
    }

    function getBomba(object: any) {
        let name = '';
        if (object.bombas && object.bombas.length > 0) {
            if (object.bombas.length > 1) {
                name = 'VÁRIOS MODELOS';
            } else {
                name = object.bombas[0].nome;
            }
        } else {
            name = 'N/A';
        }
        return name;
    }

    return (
        <Page error={error} loading={loading}>
            <Page.Title>
                <Typography variant="h6" component="div">
                    Modelos
                </Typography>
                {permissions.has('modelo.show') &&
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={() => history.push('/modelos/create')}>
                        Novo Modelo
                    </Button>
                }
            </Page.Title>
            {data &&
                <Page.Section>
                    <Page.Toolbar>
                        <SearchField
                            placeholder="Pesquisa"
                            value={search}
                            onChange={(event) => setSearch(event.target.value)}
                            onKeyUp={(event) => handleSearchKeyUp(event)}
                            onClick={() => handleFetch(1)}
                        />
                    </Page.Toolbar>
                    <Page.Content>
                        <TableContainer>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>ID</TableCell>
                                        <TableCell>Modelo</TableCell>
                                        <TableCell>Tipo</TableCell>
                                        <TableCell>Bomba</TableCell>
                                        <TableCell>Ativo</TableCell>
                                        <TableCell>Data Criação</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data.data.map((modelo) => (
                                        <TableRow
                                            key={modelo.id}
                                            hover={true}
                                            onClick={() => history.push(`/modelos/${modelo.id}`)}
                                        >
                                            <TableCell>{modelo.id}</TableCell>
                                            <TableCell>{modelo.nome}</TableCell>
                                            <TableCell>{modelo.tipo}</TableCell>
                                            <TableCell><Chip label={getBomba(modelo)} /></TableCell>
                                            <TableCell>{modelo.ativa ? 'Sim' : 'Não'}</TableCell>
                                            <TableCell>{moment(modelo.created_at).format('DD/MM/YYYY')}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Box p={2}>
                            <Grid container justifyContent="center">
                                <Pagination
                                    page={data.current_page}
                                    count={data.last_page}
                                    onChange={(_event, page) => handleFetch(page)}
                                    color="secondary"
                                />
                            </Grid>
                        </Box>
                    </Page.Content>
                </Page.Section>
            }
        </Page >
    );
}

export default Modelos;